// GENERATED CODE
// This file is generated by a Python script so do not change it, change the script!
// Script: tools/codegen/generate_vat_fields.py
// Template: tools/codegen/templates/skv_vat_field.ts
import { z } from 'zod';

// prettier-ignore
export const vatFields = [
  '05',
  '06',
  '07',
  '08',
  '10',
  '11',
  '12',
  '20',
  '21',
  '22',
  '23',
  '24',
  '30',
  '31',
  '32',
  '35',
  '36',
  '37',
  '38',
  '39',
  '40',
  '41',
  '42',
  '48',
  '49',
  '50',
  '60',
  '61',
  '62',
  '480',
] as const;
export type VatField = (typeof vatFields)[number];
export const vatFieldSchema = z.enum(vatFields);
export const vatFieldDecoder = (value: unknown): VatField => vatFieldSchema.parse(value);
export function isVatField(code: unknown): code is VatField {
  return vatFields.includes(code as VatField);
}

export const VAT_SUFFIX_FIELDS = [
  '05',
  '06',
  '07',
  '08',
  '20',
  '21',
  '22',
  '23',
  '24',
  '50',
] as const;
type VatSuffixField = (typeof VAT_SUFFIX_FIELDS)[number];
export function isVatSuffixField(code: unknown): code is VatSuffixField {
  return VAT_SUFFIX_FIELDS.includes(code as VatSuffixField);
}

// Field 49 is calculated from its dependencies, never directly mapped.
export const FIELD_49_DEPS: VatField[] = ['10', '11', '12', '30', '31', '32', '60', '61', '62'];

// Fields 49 and 480 cannot be mapped directly — 49 is calculated, 480 is the shadow section.
export const mappableVatFields = vatFields.filter(
  (f): f is MappableVatField => f !== '49' && f !== '480',
);
export type MappableVatField = Exclude<VatField, '49' | '480'>;
export function isMappableVatField(code: unknown): code is MappableVatField {
  return isVatField(code) && code !== '49' && code !== '480';
}

// prettier-ignore
export const vatBlocks = [
  'ImportsBasis',
  'ImportsVat',
  'ReverseChargeVat',
  'ReverseChargeVatBasis',
  'SalesVat',
  'TaxableSalesBasis',
  'VatCalculation',
  'VatCalculationResult',
  'VatExemptSales',
] as const;
export type VatBlock = (typeof vatBlocks)[number];
export function isVatBlock(code: unknown): code is VatBlock {
  return vatBlocks.includes(code as VatBlock);
}

type FieldInfo = {
  description: string;
  block: VatBlock;
  sortPriority: number;
};

// prettier-ignore
export function getVatFieldInfo(code: VatField): FieldInfo {
  switch (code) {
    case '05':
      return {description: 'Momspliktig försäljning som inte ingår i ruta 06, 07 eller 08', block: 'TaxableSalesBasis', sortPriority: 5};
    case '06':
      return {description: 'Momspliktiga uttag', block: 'TaxableSalesBasis', sortPriority: 6};
    case '07':
      return {description: 'Beskattningsunderlag vid vinstmarginalbeskattning', block: 'TaxableSalesBasis', sortPriority: 7};
    case '08':
      return {description: 'Hyresinkomster vid frivillig skattskyldighet', block: 'TaxableSalesBasis', sortPriority: 8};
    case '10':
      return {description: 'Utgående moms 25%', block: 'SalesVat', sortPriority: 10};
    case '11':
      return {description: 'Utgående moms 12%', block: 'SalesVat', sortPriority: 11};
    case '12':
      return {description: 'Utgående moms 6%', block: 'SalesVat', sortPriority: 12};
    case '20':
      return {description: 'Inköp av varor från ett annat EU-land', block: 'ReverseChargeVatBasis', sortPriority: 20};
    case '21':
      return {description: 'Inköp av tjänster från annat EU-land enligt huvudregeln', block: 'ReverseChargeVatBasis', sortPriority: 21};
    case '22':
      return {description: 'Inköp av tjänster från land utanför EU', block: 'ReverseChargeVatBasis', sortPriority: 22};
    case '23':
      return {description: 'Inköp av varor i Sverige som köparen är skattskyldig för', block: 'ReverseChargeVatBasis', sortPriority: 23};
    case '24':
      return {description: 'Övriga inköp av tjänster i Sverige som köparen är skattskyldig för', block: 'ReverseChargeVatBasis', sortPriority: 24};
    case '30':
      return {description: 'Utgående moms 25%', block: 'ReverseChargeVat', sortPriority: 30};
    case '31':
      return {description: 'Utgående moms 12%', block: 'ReverseChargeVat', sortPriority: 31};
    case '32':
      return {description: 'Utgående moms 6%', block: 'ReverseChargeVat', sortPriority: 32};
    case '35':
      return {description: 'Försäljning av varor till ett annat EU-land', block: 'VatExemptSales', sortPriority: 35};
    case '36':
      return {description: 'Försäljning av varor utanför EU', block: 'VatExemptSales', sortPriority: 36};
    case '37':
      return {description: 'Mellanmans inköp av varor vid tredjepartshandel', block: 'VatExemptSales', sortPriority: 37};
    case '38':
      return {description: 'Mellanmans försäljning av varor vid tredjepartshandel', block: 'VatExemptSales', sortPriority: 38};
    case '39':
      return {description: 'Försäljning av tjänster till näringsidkare i annat EU-land enligt huvudregeln', block: 'VatExemptSales', sortPriority: 39};
    case '40':
      return {description: 'Övrig försäljning av tjänster omsatta utanför Sverige', block: 'VatExemptSales', sortPriority: 40};
    case '41':
      return {description: 'Försäljning när köparen är skattskyldig i Sverige', block: 'VatExemptSales', sortPriority: 41};
    case '42':
      return {description: 'Övrig försäljning m.m.', block: 'VatExemptSales', sortPriority: 42};
    case '48':
      return {description: 'Ingående moms att dra av', block: 'VatCalculation', sortPriority: 48};
    case '49':
      return {description: 'Moms att betala eller få tillbaka', block: 'VatCalculationResult', sortPriority: 49};
    case '50':
      return {description: 'Beskattningsunderlag vid import', block: 'ImportsBasis', sortPriority: 50};
    case '60':
      return {description: 'Utgående moms 25%', block: 'ImportsVat', sortPriority: 60};
    case '61':
      return {description: 'Utgående moms 12%', block: 'ImportsVat', sortPriority: 61};
    case '62':
      return {description: 'Utgående moms 6%', block: 'ImportsVat', sortPriority: 62};
    case '480':
      return {description: 'Ingående moms (skuggruta)', block: 'VatCalculation', sortPriority: 480};
  }
}

export function vatFieldFromString(code: string): VatField {
  switch (code) {
    case '05':
      return '05';
    case '06':
      return '06';
    case '07':
      return '07';
    case '08':
      return '08';
    case '10':
      return '10';
    case '11':
      return '11';
    case '12':
      return '12';
    case '20':
      return '20';
    case '21':
      return '21';
    case '22':
      return '22';
    case '23':
      return '23';
    case '24':
      return '24';
    case '30':
      return '30';
    case '31':
      return '31';
    case '32':
      return '32';
    case '35':
      return '35';
    case '36':
      return '36';
    case '37':
      return '37';
    case '38':
      return '38';
    case '39':
      return '39';
    case '40':
      return '40';
    case '41':
      return '41';
    case '42':
      return '42';
    case '48':
      return '48';
    case '49':
      return '49';
    case '50':
      return '50';
    case '60':
      return '60';
    case '61':
      return '61';
    case '62':
      return '62';
    case '480':
      return '480';
  }
  throw new Error('Invalid VAT field code: ' + code);
}

// TODO#1844 - tidigare EMXIF ...
// code below should be generated (maybe not translateVatBlock)
// and types above synchronized, e.g. union from array ...

// This is the preferred order (but it is not in numeric order)
// prettier-ignore
export const rawVatBlocks: VatBlock[] = [
  'TaxableSalesBasis',
  'SalesVat',
  'ReverseChargeVatBasis',
  'ReverseChargeVat',
  'VatExemptSales',
  'ImportsBasis',
  'ImportsVat',
  'VatCalculation',
  'VatCalculationResult',
];

export const sortVatFields = <T extends VatField | MappableVatField>(vatFields: T[]) => {
  return [...vatFields].sort((a, b) => {
    const aInfo = getVatFieldInfo(a);
    const bInfo = getVatFieldInfo(b);
    const aBlock = rawVatBlocks.indexOf(aInfo.block);
    const bBlock = rawVatBlocks.indexOf(bInfo.block);

    return aBlock * 100 + aInfo.sortPriority - (bBlock * 100 + bInfo.sortPriority);
  });
};

// prettier-ignore
export function translateVatBlock(block: VatBlock): string {
  switch (block) {
    case 'ImportsBasis':
      return 'Moms vid import';
    case 'ImportsVat':
      return 'Utgående moms på import';
    case 'ReverseChargeVat':
      return 'Utgående moms på inköp';
    case 'ReverseChargeVatBasis':
      return 'Momspliktiga inköp vid omvänd betalningsskyldighet';
    case 'SalesVat':
      return 'Utgående moms på försäljning eller uttag';
    case 'TaxableSalesBasis':
      return 'Momspliktig försäljning eller uttag';
    case 'VatCalculation':
      return 'Ingående moms';
    case 'VatCalculationResult':
      return 'Moms att betala eller få tillbaka';
    case 'VatExemptSales':
      return 'Försäljning med mera som är undantagen från moms';
  }
}
